/* eslint import/prefer-default-export: 0 */
export { default as wrapRootElement } from './scripts/wrap-with-provider';
